<template>
  <div>
    <template v-if="show">
      <CRow class="gap-4 mx-4 my-4">
        <FilterInput
          v-for="(item, index) in filters"
          :key="index"
          :item="item"
          v-model="value[item.nombre]"
          @change="actulizar"
        />
      </CRow>
    </template>
  </div>
</template>

<script>
import FilterInput from "./FilterInput";
export default {
  name: "FiltrosParams",
  components: {
    FilterInput
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    preFiltros: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    reporte() {
      return this.$route?.params?.reporte;
    },
  },
  watch: {
    value(newValue) {
      console.log('watch:value', newValue)
      this.$emit("input", newValue);
      this.$emit("change", newValue);
    },
    reporte(){
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    },
    preFiltros(nV,oV){
      console.log({nV,oV})
      //debugger
    }
  },
  data() {
    return {
      value: {...this.preFiltros},
      isLoading: false,
      show: true
    };
  },
  created() {
  
    
    this.value = Object.keys(this.$store.getters.analyticsFilter).length
      ? this.filters.reduce(
          (v, c) => {
            console.log({v,c})
            return({
            ...v,
            [c.nombre]: this.value[c.nombre]||this.$store.getters.analyticsFilter[c.nombre]
          })},
          this.preFiltros||{}
        )
      : (this.preFiltros||{});
    console.log(this.value)
    
  },
  methods: {
    actulizar() {
      this.$store.dispatch('setAnalyticsFilter', this.value)
      console.log('methods:actulizar', this.value)
      this.$emit("input", this.value);
      this.$emit("change", this.value);
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style lang="scss" scoped>
.gan-1 {
  gap: 0.25rem !important;
}
.gan-2 {
  gap: 0.5rem !important;
}
.gan-3 {
  gap: 1rem !important;
}
.gan-4 {
  gap: 1.5rem !important;
}
.gan-5 {
  gap: 3rem !important;
}
</style>
